import { configureStore } from "@reduxjs/toolkit";
import langReducer from "./langSlice";
import authReducer, { checkTokenExpirationDate } from "./authSlice";
import orderReducer from "./orderSlice";
import financeReducer from "./financeSlice";
import loadingReducer from "./loadingSlice";
import messageModalReducer from "./messageModalSlice";
import messageNotificationReducer from "./messageNotificationSlice";
import notificationReducer from "./notificationSlice";
import skanoModalReducer from "./skanoModalSlice";

const store = configureStore({
	reducer: {
		langReducer,
		auth: authReducer,
		order: orderReducer,
		finance: financeReducer,
		loading: loadingReducer,
		messageModal: messageModalReducer,
		message: messageNotificationReducer,
		notification: notificationReducer,
		skanoModal: skanoModalReducer,
	},
});
store.dispatch(checkTokenExpirationDate());
export type RootState = ReturnType<typeof store.getState>;
export default store;
